export default __webpack_public_path__ + "static/media/mindy_branding_1.a1876b37.svg";